import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';
import { env } from './env';
import { CookieStorage } from './cookieStorage';

const supabaseUrl = env.VITE_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Create Supabase client with cross-subdomain auth configuration
// Uses cookies with domain=.gomecano.com to share sessions between subdomains
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    // CRITICAL: Must be identical across all 3 projects (dashboard, tools, amv)
    storageKey: 'gomecano-auth',
    // Use custom cookie storage instead of localStorage
    // Cookies can be shared across subdomains with domain=.gomecano.com
    storage: typeof window !== 'undefined' ? new CookieStorage() : undefined,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'x-application': 'amv-gomecano'
    }
  }
});
